import { render } from "./LoginRoles.vue?vue&type=template&id=4dd2618b&scoped=true"
import script from "./LoginRoles.vue?vue&type=script&lang=js"
export * from "./LoginRoles.vue?vue&type=script&lang=js"

import "./LoginRoles.vue?vue&type=style&index=0&id=4dd2618b&scoped=true&lang=css"

import exportComponent from "/Users/bobbarnard/Documents/sources/bungalow7-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd2618b"]])

export default __exports__